/* global axios */
import ApiClient from './ApiClient';

const TAB_UNREAD_REQUEST_TIMEOUT_MS = 10000;

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  getTabUnreadCount(accountId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/conversations/tab_unread_count`,
      { timeout: TAB_UNREAD_REQUEST_TIMEOUT_MS }
    );
  }
}

export default new ConversationApi();
